// NewMailModal.js
import React, {useContext, useState} from 'react';
import { Box, TextField, Button, Modal, Grid } from '@mui/material';
import axios from 'axios';
import {UserContext} from "./UserContext";

const newMailFill = '#353739';
const newMailColor = '#7F7F7F';

const NewMailModal = ({ open, handleClose }) => {

    const [recipientsTo, setRecipientsTo] = useState("");
    const [recipientsCc, setRecipientsCc] = useState("");
    const [recipientsBcc, setRecipientsBcc] = useState("");
    const [subject, setSubject] = useState("");
    const [content, setContent] = useState("");
    const userContext = useContext(UserContext);
    const [emailAddress, setEmailAddress] = useState(userContext.email);
    const [password, setPassword] = useState(userContext.password);

    const handleSend = async () => {

        const emailData = {
            email_address: userContext.email,
            password: userContext.password,
            recipients_to: recipientsTo.split(';'),
            recipients_cc: recipientsCc.split(';'),
            recipients_bcc: recipientsBcc.split(';'),
            subject: subject,
            content: content
        };

        try {
            const response = await axios.post('https://boring-ride.95-216-35-79.plesk.page:5000/send_email', emailData);
            if (response.status === 200) {
                alert('Die E-Mail wurde erfolgreich versendet.');
            } else {
                alert('Beim Senden der E-Mail ist ein Fehler aufgetreten.');
            }
        } catch (error) {
            console.error("Es gab einen Fehler beim Senden der E-Mail: ", error);
        }

        handleClose();
    }

    return (
        <Modal open={open} onClose={handleClose}>
            <Box
                sx={{
                    position: 'absolute',
                    width: 800,
                    backgroundColor: 'white',
                    border: '2px solid #000',
                    boxShadow: 24,
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    borderRadius: 2,
                }}
            >
                <Grid container spacing={2}>
                    <Grid item xs={6} sx={{ bgcolor: '#262626', p: 3 }}>

                        <TextField
                            fullWidth
                            label="Empfänger (To)"
                            variant="outlined"
                            value={recipientsTo}
                            onChange={e => setRecipientsTo(e.target.value)}
                            sx={{ mb: 2, ...textFieldStyle }}
                        />
                        <TextField
                            fullWidth
                            label="Empfänger (CC)"
                            variant="outlined"
                            value={recipientsCc}
                            onChange={e => setRecipientsCc(e.target.value)}
                            sx={{ mb: 2, ...textFieldStyle }}
                        />
                        <TextField
                            fullWidth
                            label="Empfänger (BCC)"
                            variant="outlined"
                            value={recipientsBcc}
                            onChange={e => setRecipientsBcc(e.target.value)}
                            sx={{ mb: 2, ...textFieldStyle }}
                        />
                        <TextField
                            fullWidth
                            label="Betreff"
                            variant="outlined"
                            value={subject}
                            onChange={e => setSubject(e.target.value)}
                            sx={{ mb: 2, ...textFieldStyle }}
                        />
                    </Grid>
                    <Grid item xs={6} sx={{ bgcolor: '#1F1F1F', borderLeft: '1px solid rgba(127,127,127,0.2)', p: 3 }}>
                        <TextField
                            fullWidth
                            label="Inhalt"
                            multiline
                            rows={14}
                            variant="outlined"
                            value={content}
                            onChange={e => setContent(e.target.value)}
                            sx={{ mb: 2, ...textFieldStyle }}
                        />
                        <Button variant="contained" disableElevation sx={{bgcolor: '#006AD4', boxShadow: 'none', mr: 2 }} onClick={handleSend}>
                            Senden
                        </Button>
                        <Button variant="outlined" onClick={handleClose}>
                            Verwerfen
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </Modal>
    );
}

// Style for the text fields, to avoid repetition
const textFieldStyle = {
    '.MuiOutlinedInput-root': {
        bgcolor: newMailFill,
        color: newMailColor,
        '& fieldset': {
            borderColor: newMailColor,
        },
        '&:hover fieldset': {
            borderColor: newMailColor,
        },
        '&.Mui-focused fieldset': {
            borderColor: newMailColor,
        },
        '& input': {  // Changing the color of the text to white when typing
            color: 'white',
        },
        '& textarea': {  // Changing the color of the text to white when typing
            color: 'white',
        },
    },
    '.MuiInputLabel-root': {
        color: newMailColor,
    },
};

export default NewMailModal;
